import React from 'react';

/* ── Shared SVG wrapper ── */
const Svg = ({ size = 22, children, fill, stroke, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={fill !== undefined ? fill : 'none'}
    stroke={stroke !== undefined ? stroke : 'currentColor'}
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ display: 'block', flexShrink: 0 }}
    {...rest}
  >
    {children}
  </svg>
);

/* ── Icon components ── */
export const Hammer = ({ size }) => (
  <Svg size={size}>
    <path d="M15 12l-8.5 8.5a2.12 2.12 0 01-3-3L12 9" />
    <path d="M17.64 15L22 10.64" />
    <path d="M20.91 11.7l-1.25-1.25c-.6-.6-.93-1.4-.93-2.25v-.86L16.01 4.6a5.56 5.56 0 00-3.94-1.64H9l.92.82A6.18 6.18 0 0112 8.4v1.56l2 2h2.47l2.26 2.91" />
  </Svg>
);

export const Clipboard = ({ size }) => (
  <Svg size={size}>
    <rect x="9" y="2" width="6" height="4" rx="1" />
    <path d="M9 2H7a2 2 0 00-2 2v16a2 2 0 002 2h10a2 2 0 002-2V4a2 2 0 00-2-2h-2" />
    <line x1="9" y1="11" x2="15" y2="11" />
    <line x1="9" y1="15" x2="13" y2="15" />
  </Svg>
);

export const Building = ({ size }) => (
  <Svg size={size}>
    <rect x="3" y="3" width="18" height="18" rx="1" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="9" y1="9" x2="9" y2="21" />
    <line x1="3" y1="15" x2="9" y2="15" />
  </Svg>
);

export const TrendingUp = ({ size }) => (
  <Svg size={size}>
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </Svg>
);

export const Receipt = ({ size }) => (
  <Svg size={size}>
    <polyline points="3 3 3 21 6 19 9 21 12 19 15 21 18 19 21 21 21 3" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="8" y1="14" x2="14" y2="14" />
  </Svg>
);

export const Handshake = ({ size }) => (
  <Svg size={size}>
    <path d="M20.5 14.5l-5 5a2 2 0 01-2.83 0L9 16" />
    <path d="M3.5 9.5l5-5a2 2 0 012.83 0L15 8" />
    <path d="M9 16l-4.5-4.5a2 2 0 010-2.83L9 4" />
    <path d="M15 8l4.5 4.5a2 2 0 010 2.83L15 20" />
  </Svg>
);

export const Scale = ({ size }) => (
  <Svg size={size}>
    <path d="M12 2v20" />
    <line x1="3" y1="22" x2="21" y2="22" />
    <path d="M3 7l9-5 9 5" />
    <path d="M6 7L3 14a3 3 0 006 0L6 7z" />
    <path d="M18 7l-3 7a3 3 0 006 0L18 7z" />
  </Svg>
);

export const Home = ({ size }) => (
  <Svg size={size}>
    <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
    <polyline points="9 22 9 12 15 12 15 22" />
  </Svg>
);

export const FileText = ({ size }) => (
  <Svg size={size}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </Svg>
);

export const Shield = ({ size }) => (
  <Svg size={size}>
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
  </Svg>
);

export const MessageCircle = ({ size }) => (
  <Svg size={size}>
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
  </Svg>
);

export const BookOpen = ({ size }) => (
  <Svg size={size}>
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" />
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" />
  </Svg>
);

export const Phone = ({ size }) => (
  <Svg size={size}>
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.02 2.18 2 2 0 012 .02h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </Svg>
);

export const Video = ({ size }) => (
  <Svg size={size}>
    <polygon points="23 7 16 12 23 17 23 7" />
    <rect x="1" y="5" width="15" height="14" rx="2" />
  </Svg>
);

export const Star = ({ size, filled }) => (
  <Svg size={size} fill={filled ? 'currentColor' : 'none'} stroke={filled ? 'none' : 'currentColor'}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </Svg>
);

export const Lock = ({ size }) => (
  <Svg size={size}>
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0110 0v4" />
  </Svg>
);

export const Check = ({ size }) => (
  <Svg size={size}>
    <polyline points="20 6 9 17 4 12" />
  </Svg>
);

export const Users = ({ size }) => (
  <Svg size={size}>
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87" />
    <path d="M16 3.13a4 4 0 010 7.75" />
  </Svg>
);

export const Wrench = ({ size }) => (
  <Svg size={size}>
    <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z" />
  </Svg>
);

export const Link = ({ size }) => (
  <Svg size={size}>
    <path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" />
  </Svg>
);

export const Euro = ({ size }) => (
  <Svg size={size}>
    <text
      x="12" y="17"
      textAnchor="middle"
      fontSize="16"
      fontWeight="bold"
      stroke="none"
      fill="currentColor"
      fontFamily="sans-serif"
    >€</text>
  </Svg>
);

export const Folder = ({ size }) => (
  <Svg size={size}>
    <path d="M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
  </Svg>
);

export const Search = ({ size }) => (
  <Svg size={size}>
    <circle cx="11" cy="11" r="7" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </Svg>
);

export const Download = ({ size }) => (
  <Svg size={size}>
    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
    <polyline points="7 10 12 15 17 10" />
    <line x1="12" y1="15" x2="12" y2="3" />
  </Svg>
);

export const Play = ({ size }) => (
  <Svg size={size} fill="currentColor" stroke="none">
    <polygon points="6 4 20 12 6 20 6 4" />
  </Svg>
);

export const Sheet = ({ size }) => (
  <Svg size={size}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <line x1="3" y1="9" x2="21" y2="9" />
    <line x1="3" y1="15" x2="21" y2="15" />
    <line x1="9" y1="3" x2="9" y2="21" />
    <line x1="15" y1="3" x2="15" y2="21" />
  </Svg>
);

export const Eye = ({ size }) => (
  <Svg size={size}>
    <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" />
    <circle cx="12" cy="12" r="3" />
  </Svg>
);

export const Calendar = ({ size }) => (
  <Svg size={size}>
    <rect x="3" y="4" width="18" height="18" rx="2" />
    <line x1="16" y1="2" x2="16" y2="6" />
    <line x1="8" y1="2" x2="8" y2="6" />
    <line x1="3" y1="10" x2="21" y2="10" />
  </Svg>
);

export const Clock = ({ size }) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <polyline points="12 7 12 12 15 14" />
  </Svg>
);

export const Mic = ({ size }) => (
  <Svg size={size}>
    <rect x="9" y="2" width="6" height="12" rx="3" />
    <path d="M5 10v1a7 7 0 0014 0v-1" />
    <line x1="12" y1="18" x2="12" y2="22" />
  </Svg>
);

export const Tag = ({ size }) => (
  <Svg size={size}>
    <path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z" />
    <line x1="7" y1="7" x2="7.01" y2="7" />
  </Svg>
);

export const ChevronRight = ({ size }) => (
  <Svg size={size}>
    <polyline points="9 6 15 12 9 18" />
  </Svg>
);

export const ChevronLeft = ({ size }) => (
  <Svg size={size}>
    <polyline points="15 6 9 12 15 18" />
  </Svg>
);

export const HelpCircle = ({ size }) => (
  <Svg size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </Svg>
);

export const X = ({ size }) => (
  <Svg size={size}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </Svg>
);

export const Paperclip = ({ size }) => (
  <Svg size={size}>
    <path d="M21.44 11.05l-9.19 9.19a5 5 0 01-7.07-7.07l9.19-9.19a3.5 3.5 0 014.95 4.95l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" />
  </Svg>
);

export const Briefcase = ({ size }) => (
  <Svg size={size}>
    <rect x="2" y="7" width="20" height="14" rx="2" />
    <path d="M8 7V5a2 2 0 012-2h4a2 2 0 012 2v2" />
    <line x1="2" y1="13" x2="22" y2="13" />
  </Svg>
);

export const Store = ({ size }) => (
  <Svg size={size}>
    <path d="M3 10v9a1 1 0 001 1h16a1 1 0 001-1v-9" />
    <path d="M3 10l1.8-5.4A1 1 0 015.75 4h12.5a1 1 0 01.95.68L21 10" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <path d="M9 20v-5h6v5" />
  </Svg>
);

export const MapPin = ({ size }) => (
  <Svg size={size}>
    <path d="M21 10c0 7-9 12-9 12s-9-5-9-12a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </Svg>
);

export const Megaphone = ({ size }) => (
  <Svg size={size}>
    <path d="M3 9v6a1 1 0 001 1h3l6 4V4L7 8H4a1 1 0 00-1 1z" />
    <path d="M16 9a3 3 0 010 6" />
  </Svg>
);

export const Camera = ({ size }) => (
  <Svg size={size}>
    <path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z" />
    <circle cx="12" cy="13" r="4" />
  </Svg>
);

export const Pencil = ({ size }) => (
  <Svg size={size}>
    <path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z" />
  </Svg>
);

export const RotateCcw = ({ size }) => (
  <Svg size={size}>
    <path d="M1 4v6h6" />
    <path d="M3.51 15a9 9 0 102.13-9.36L1 10" />
  </Svg>
);

export const Flame = ({ size }) => (
  <Svg size={size}>
    <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z" />
  </Svg>
);

export const UserPlus = ({ size }) => (
  <Svg size={size}>
    <path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="8.5" cy="7" r="4" />
    <path d="M20 8v6M23 11h-6" />
  </Svg>
);

export const GraduationCap = ({ size }) => (
  <Svg size={size}>
    <path d="M22 10L12 5 2 10l10 5 10-5z" />
    <path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5" />
  </Svg>
);

export const Bell = ({ size }) => (
  <Svg size={size}>
    <path d="M18 8a6 6 0 00-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 01-3.46 0" />
  </Svg>
);

export const Ticket = ({ size }) => (
  <Svg size={size}>
    <path d="M2 9a3 3 0 010 6v2a2 2 0 002 2h16a2 2 0 002-2v-2a3 3 0 010-6V7a2 2 0 00-2-2H4a2 2 0 00-2 2v2z" />
    <path d="M13 5v2M13 17v2M13 11v2" />
  </Svg>
);

export const ChevronDown = ({ size }) => (
  <Svg size={size}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);

export const Copy = ({ size }) => (
  <Svg size={size}>
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </Svg>
);

export const Share = ({ size }) => (
  <Svg size={size}>
    <path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" />
    <path d="M16 6l-4-4-4 4" />
    <path d="M12 2v13" />
  </Svg>
);

/* ── IconBadge wrapper ── */
export function IconBadge({ children, accent = true, size: badgeSize = 38, iconSize }) {
  return (
    <div style={{
      width: badgeSize,
      height: badgeSize,
      borderRadius: 12,
      background: accent ? 'rgba(255,214,0,0.12)' : 'var(--bg-elevated)',
      color: accent ? 'var(--accent)' : 'var(--text-secondary)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}>
      {React.cloneElement(children, { size: iconSize || Math.round(badgeSize * 0.5) })}
    </div>
  );
}
